import { Link } from "react-router-dom";
import { contactInfo, footerLinks } from "../../../mocks/homeData";

export default function Footer() {
  return (
    <footer className="bg-navy">
      <div className="border-t-2 border-copper" />
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
          <div>
            <div className="mb-4">
              <Link to="/">
                <img
                  src="https://static.readdy.ai/image/b5368476057c9c8f26b27413f3f8af69/3fb6cbd3d96d84689ba7b723402339f2.png"
                  alt="Hangar Mühendislik Logo"
                  className="h-10 w-auto"
                />
              </Link>
            </div>
            <p className="font-body text-sm text-white/60 leading-relaxed mb-6">
              Endüstriyel çelik konstrüksiyon, fabrika yapıları, depo
              inşaatları ve anahtar teslim projelerde 15+ yıllık tecrübe.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/20 hover:border-copper hover:bg-copper flex items-center justify-center text-white/60 hover:text-white transition-all duration-300"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-linkedin-fill" />
                </div>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/20 hover:border-copper hover:bg-copper flex items-center justify-center text-white/60 hover:text-white transition-all duration-300"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-instagram-line" />
                </div>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/20 hover:border-copper hover:bg-copper flex items-center justify-center text-white/60 hover:text-white transition-all duration-300"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-facebook-fill" />
                </div>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/20 hover:border-copper hover:bg-copper flex items-center justify-center text-white/60 hover:text-white transition-all duration-300"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-youtube-line" />
                </div>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-base text-white mb-4">
              Hızlı Linkler
            </h3>
            <ul className="space-y-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="font-body text-sm text-white/60 hover:text-copper transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-base text-white mb-4">
              İletişim
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-copper mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line" />
                </div>
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, "")}`}
                  className="font-body text-sm text-white/60 hover:text-copper transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-copper mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line" />
                </div>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="font-body text-sm text-white/60 hover:text-copper transition-colors"
                >
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-copper mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line" />
                </div>
                <span className="font-body text-sm text-white/60">
                  {contactInfo.address}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-copper mt-0.5 flex-shrink-0">
                  <i className="ri-time-line" />
                </div>
                <span className="font-body text-sm text-white/60">
                  {contactInfo.workingHours}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-5 md:py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="font-body text-xs text-white/40 text-center sm:text-left">
              &copy; {new Date().getFullYear()} Hangar Mühendislik San.Tic.A.Ş.
              Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="font-body text-xs text-white/40 hover:text-copper transition-colors"
              >
                KVKK Aydınlatma Metni
              </a>
              <a
                href="#"
                className="font-body text-xs text-white/40 hover:text-copper transition-colors"
              >
                Gizlilik Politikası
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}